import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useLockerServiceProductRental from "hooks/useLockerServiceProductRental";
import RouteFallback from "./RouteFallback";

type InventoryRentalRouteGuardProps = PropsWithChildren<{
  redirectTo?: string;
}>;

export default function InventoryRentalRouteGuard({
  children,
  redirectTo = "/",
}: InventoryRentalRouteGuardProps) {
  const navigate = useNavigate();
  const { enabled, isReady } = useLockerServiceProductRental();

  useEffect(() => {
    if (isReady && !enabled) {
      navigate(redirectTo, { replace: true });
    }
  }, [enabled, isReady, navigate, redirectTo]);

  if (!isReady) return <RouteFallback />;
  if (!enabled) return null;

  return <>{children}</>;
}
